export default __webpack_public_path__ + "static/media/maisons_laffitte4.43c4773d.jpg";